import { render, staticRenderFns } from "./templateword.vue?vue&type=template&id=0f545bc0&scoped=true&"
import script from "./templateword.vue?vue&type=script&lang=js&"
export * from "./templateword.vue?vue&type=script&lang=js&"
import style0 from "./templateword.vue?vue&type=style&index=0&id=0f545bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f545bc0",
  null
  
)

export default component.exports